export class SorterAlertHistoryReportRowDto {
    id: number;
    deviceId: number;
    timestampUtc: string;
    alertText: string;
    emailSent: boolean;

    deviceBranchId: number;
    deviceName: string;
    deviceBookmaticStatusId: number | null;
    deviceBookmaticStatusName: string;
    deviceLastStatusUpdateUtc: string | null;

    // display overrides
    emailSentDisplay: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/reports/sorter/sorter-alert-history-report-row.dto.ts